import { render } from "./AddNewContactModal.vue?vue&type=template&id=7370e7bd&ts=true"
import script from "./AddNewContactModal.vue?vue&type=script&lang=ts"
export * from "./AddNewContactModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__